import * as Shape from './shape';
export * from '@antv/g-base';
export { IElement } from './interfaces';
export { Region } from './types';
export { default as Canvas } from './canvas';
export { default as Group } from './group';
export { Shape };
export { default as getArcParams } from './util/arc-params';

export const version = '0.5.12';
